import {EnvironmentProviders, Provider} from '@angular/core';
import {AuthHttpInterceptor, provideAuth0} from '@auth0/auth0-angular';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ENVIRONMENT} from '../../../environments/environment';

export const provideAuth = (): (Provider | EnvironmentProviders)[] => {
  return [
    provideAuth0({
      domain: ENVIRONMENT.auth0.domain,
      clientId: ENVIRONMENT.auth0.clientId,
      authorizationParams: {
        redirect_uri: ENVIRONMENT.url,
        audience: ENVIRONMENT.api.url,
        scope: ENVIRONMENT.auth0.authorizationParams.scope,
      },
      httpInterceptor: {
         allowedList: [`${ENVIRONMENT.api.url}/api/*`],
    //   {
    //   uri: `${ENVIRONMENT.api.url}/api/*`,
    //   tokenOptions: {
    //     authorizationParams: {
    //       audience: ENVIRONMENT.api.url,
    //       scope: ENVIRONMENT.auth0.authorizationParams.scope,
    //     }
    //   }
    // }
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    }
  ]
}
